import { ITableViewContext } from 'framework/table/ITableViewContext';
import { IStockEntryDto } from 'gen/ApiClient';
import React from 'react';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, IStockEntryDto> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
